import { render, staticRenderFns } from "./Demandas.vue?vue&type=template&id=0627f200&scoped=true&"
import script from "./Demandas.vue?vue&type=script&lang=js&"
export * from "./Demandas.vue?vue&type=script&lang=js&"
import style0 from "./Demandas.vue?vue&type=style&index=0&id=0627f200&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0627f200",
  null
  
)

export default component.exports